import { ErrorDetailMap } from '@paywithextend/components/dist/error.utils'
import { RootState } from 'src/redux/createRootReducer'

export const selectChangePasswordLoadingFromState = (
  state: RootState,
): boolean => state.app.profileSecurity.changePassword.loading
export const selectChangePasswordTopLevelErrorFromState = (
  state: RootState,
): string | undefined =>
  state.app.profileSecurity.changePassword.changePasswordTopLevelError
export const selectChangePasswordErrorDetailMapFromState = (
  state: RootState,
): ErrorDetailMap<string> | undefined =>
  state.app.profileSecurity.changePassword.changePasswordErrorDetailMap
